<template>
  <a-modal
    :visible="true"
    title="添加活动环节"
    @ok="sub"
    @cancel="cancel"
    :width="600"
  >
    <a-form
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="环节标题">
        <a-input type="text" v-model="form.sec_name"></a-input>
      </a-form-item>
      <a-form-item label="自定义字段">
        <a-input
          style="width: 120px"
          type="text"
          v-model="form._key"
          placeholder="如主讲人"
        ></a-input>
        <a-input
          style="width: 300px; margin-left: 10px"
          type="text"
          v-model="form._val"
          placeholder="如主讲人姓名"
        ></a-input>
      </a-form-item>
      <a-form-item label="环节简介">
        <a-textarea
          :auto-size="{ minRows: 3, maxRows: 6 }"
          v-model="form.desc"
        />
      </a-form-item>
      <a-form-item label="环节时间">
        <a-date-picker
          :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }"
          v-model="form.start_at"
        />
        <span style="margin: 0 10px">-</span>
        <a-date-picker
          :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }"
          v-model="form.end_at"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 19,
        },
      },
      form: {
        activity_id: 0,
        sec_name: "",
        _key: "",
        _val: "",
        desc: "",
        start_at: null,
        end_at: null,
      },
    };
  },
  created() {
    this.form.activity_id = this.$route.query.activity_id;
  },
  methods: {
    moment,
    async sub() {
      const that = this;
      const r = await that.$axios.post("/activity/section/create", this.form);

      if (r.status == 1) {
        this.callback(true);
      }
    },

    cancel() {
      this.callback(false);
    },

    callback(e) {
      this.$emit("callback", e);
    },
  },
};
</script>